import { QuestionCircleOutlined } from '@ant-design/icons';
import { MultiAccurate } from '@lcsc-design/utils/decimal';
import { Col, Row, Popover } from 'antd';

export default function DialogLeft({ row }) {
  const totalStockNumber = (row?.szValidStockNumber || 0) + (row?.jsValidStockNumber || 0);
  return (
    <>
      <div className="flex-1 w-[289px] border-r-2 border-[#F0F0F0] pr-[20px] border-solid mr-[20px]">
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            商品名称：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {row?.productName}
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            商品品牌：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {row?.brandName || row?.productGradePlateName || row?.productGradePlateNameWithoutHighlight}
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            商品编号：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {row?.productCode}
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            厂家型号：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {row?.productModel}
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            商品毛重：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {MultiAccurate(row?.productWeight || 0, 1000)} 克 (g)
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            包装方式：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            {row?.productArrange}
          </Col>
        </Row>
        <Row className="mt-[16px]">
          <Col span={6} className="text-[#54657D]">
            现货库存：
          </Col>
          <Col span={18} className="text-ellipsis whitespace-nowrap overflow-hidden text-[#000000]">
            <span className="mr-[10px]">{totalStockNumber}</span>
            <Popover
              content={
                <div>
                  <p>广东仓：{row?.szValidStockNumber || 0}</p>
                  <p>江苏仓：{row?.jsValidStockNumber || 0}</p>
                </div>
              }
              trigger="hover"
            >
              <QuestionCircleOutlined className="cursor-pointer" />
            </Popover>
          </Col>
        </Row>
      </div>
    </>
  );
}
